import { useMutation } from "@tanstack/react-query";

import { ICard } from "../types.ts";
import { cardsAPI } from "../cardsAPI.ts";
import { queryClient } from "../../../api";
import { cardListQueryKey } from "../queries";

export const useSetMainProductMutation = () => {
  return useMutation ({
    mutationKey: ["set-default-card"],
    mutationFn: async (productId: string) => {
      if (!productId) {
        throw new Error("Product ID is undefined");
      }

      const response = await cardsAPI.setMainProduct(productId);

      if (!response.isProductIdMain) {
        throw new Error("Server returned isProductIdMain: false");
      }

      return response;
    },
    onSuccess: (_, updatedProductId, __) => {
      queryClient.setQueryData<ICard[]>([cardListQueryKey], (old) => {
        if (!old) return old;

        const updatedCards: ICard[] = old.map((card) => {
          return card.productId === updatedProductId
            ? { ...card, isMainProduct: true } satisfies ICard
            : { ...card, isMainProduct: false } satisfies ICard;
        });

        return updatedCards;
      });
    },
  });
};
